import { FxWindow } from "../fxms/windows/FxWindows";
import { FxmsData } from "../fxms/datas/FxData";
import React from "react";
import { useState, useEffect, useLayoutEffect } from "react";
import { DetailModal } from "./VupComDash_1";

import "./../css/VUP_dash.css";

export const SensorCheck = (props) => {
  const complexInloNo = props.complexInloNo;
  const [commTotCnt, setCommTotCnt] = useState(1);
  const [commNomal, setCommNormal] = useState(0);
  const [commAbnormal, setCommAbnormal] = useState(0);
  const [modal, setModal] = useState(false);
  const [clickedEng, setClickedEng] = useState("");
  const [clickedCnt, setClickedCnt] = useState("");

  const inputDatas = { complexInloNo: complexInloNo };

  async function showSensor() {
    const uri = "vup/dash/sensor/state";
    try {
      const res = await FxmsData.get(uri, inputDatas);
      let index = 0;
      setCommTotCnt(JSON.stringify(res.data.comm_state.totCnt));
      setCommNormal(JSON.stringify(res.data.comm_state.onCnt));
      setCommAbnormal(JSON.stringify(res.data.comm_state.offCnt));
    } catch (e) {
      console.log(" error e : " + e);
    }
  }

  function clickHandler(click_id, click_cnt) {
    if (!modal) {
      setClickedEng(click_id);
      setClickedCnt(click_cnt);
      setModal(!modal);
    }
  }

  useEffect(() => {
    showSensor();
  }, []);

  /*useLayoutEffect(() => {
    const interval = setInterval(() => {
      showSensor();
    }, 60000);

    return () => clearInterval(interval);
  }, []);*/

  return (
    <>
      <div className="numBoxGroup">
        <div className="numBox mr20">
          <span>전체</span>
          <div className="num">
            <a
              href="#"
              className="num"
              onClick={() => clickHandler("NET", "totalCnt")}
            >
              {commTotCnt ? commTotCnt : "-"}
            </a>
          </div>
        </div>
        <div className="numBox mr20">
          <span>정상</span>
          <div className="num">
            <a
              href="#"
              className="num"
              onClick={() => clickHandler("NET", "onCnt")}
            >
              {commNomal ? commNomal : "-"}
            </a>
          </div>
        </div>
        <div className="numBox">
          <span>이상</span>
          <div className="num">
            <a
              href="#"
              className="num"
              onClick={() => clickHandler("NET", "offCnt")}
            >
              {commAbnormal ? commAbnormal : "-"}
            </a>
          </div>
        </div>

        {modal && (
          <DetailModal
            engId={clickedEng}
            cnt={clickedCnt}
            setModal={setModal}
            open={true}
            complexInloNo={complexInloNo}
          />
        )}
      </div>
    </>
  );
};
